import React from 'react'
import { connect } from 'react-redux'
import { getFormValue } from '../../public/utility'
import BonusApplicationDeatil from './BonusApplicationDeatil'
class SelectIssueDiv extends React.Component {
    state = {
        changedValues基本信息: {},
        initValues基本信息: {}
    }

    handlerConfirm = () => {
        const { onSave, onClose, dispatch, showDetail } = this.props
        const 奖金期号 = getFormValue(this, '基本信息', '奖金期号')
        Tyan.doPostEvent({
            event: 'DoesExist',
            data: {
                奖金期号
            },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                onClose && onClose()
                showDetail(props => <BonusApplicationDeatil {...props} id={id} onSave={() => onSave()} />)
            }
        })
    }

    handlerClose = () => {
        const { onClose, onSave } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        return Object.keys(changedValues基本信息).length > 0
    }

    fieldset基本信息 = () => {
        var date = new Date()
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var option = []
        if (month == 12) {
            month = 1
            year = year + 1
        }
        else {
            month = month + 1
        }
        option.push(year + '年' + month + '月')
        year = date.getFullYear()
        month = date.getMonth() + 1
        option.push(year + '年' + month + '月')
        if (month == 1) {
            month = 12
            year = year - 1
        }
        else {
            month = month - 1
        }
        option.push(year + '年' + month + '月')
        return [
            { _select: '奖金期号', options: option },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const canSave = this.canSave()
        return <Body data={this} maxWidth="600"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
                    { _button: '取消', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(SelectIssueDiv)